"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkoutStep1Creator = void 0;
var consts_1 = require("../consts");
// Membership
var checkoutStep1Creator = function (event) {
    var eventData = {
        action: "checkout-step1",
        event: "checkout-step1-load",
        eventInfo: "checkout-step1-load",
        cart: {
            product: event.eventData.cart.product.map(function (item) { return (__assign(__assign({}, item), { bundledProduct: item.bundledProduct || consts_1.NOT_AVAILABLE })); })
        },
    };
    return eventData;
};
exports.checkoutStep1Creator = checkoutStep1Creator;
